import { PhoneInputController } from '@avanta/shared/components/ui/PhoneInput';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { validateNIF } from '@avanta/shared/utils/nif';
import { type ComponentType } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';

interface AppointmentInputs {
  label: string;
  type: string;
  placeholder: string;
  required: string;
  pattern?: {
    value: RegExp;
    message: string;
  };
  validate?: (value: string) => string | boolean;
  autocomplete?: string;
  component?: ComponentType | typeof PhoneInputController;
  defaultCountry?: string;
  minLength?: {
    value: number;
    message: string;
  };
}

export type PersonalDataForm = {
  firstName: string;
  surname: string;
  nif: string;
  contactPhone: string;
};

export const inputs: Record<keyof PersonalDataForm, AppointmentInputs> = {
  firstName: {
    label: 'AppointmentsPersonalData.Form.firstName.label',
    type: 'text',
    placeholder: 'AppointmentsPersonalData.Form.firstName.placeholder',
    required: `${LOCIZE_NS.COMMON}:Common.required`,
    minLength: {
      value: 3,
      message: 'AppointmentsPersonalData.Form.firstName.error',
    },
  },
  surname: {
    label: 'AppointmentsPersonalData.Form.surname.label',
    type: 'text',
    placeholder: 'AppointmentsPersonalData.Form.surname.placeholder',
    required: `${LOCIZE_NS.COMMON}:Common.required`,
    minLength: {
      value: 3,
      message: 'AppointmentsPersonalData.Form.surname.error',
    },
  },
  contactPhone: {
    component: PhoneInputController,
    label: 'AppointmentsPersonalData.Form.contactPhone.label',
    type: 'phone',
    placeholder: 'AppointmentsPersonalData.Form.contactPhone.placeholder',
    required: `${LOCIZE_NS.COMMON}:Common.required`,
    autocomplete: 'tel',
    defaultCountry: 'ES',
    validate: (value: string) => {
      if (!value) return `${LOCIZE_NS.COMMON}:Common.required`;
      return isValidPhoneNumber(value) || 'AppointmentsPersonalData.Form.contactPhone.error';
    },
  },
  nif: {
    label: 'AppointmentsPersonalData.Form.nif.label',
    type: 'text',
    placeholder: 'AppointmentsPersonalData.Form.nif.placeholder',
    required: `${LOCIZE_NS.COMMON}:Common.required`,
    validate: (value: string) => validateNIF(value) || 'AppointmentsPersonalData.Form.nif.error',
  },
};
